import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { FeatureFlagService } from '@app/shared/services/feature-flag.service';
import { AuthService } from '@app/core/services/auth.service';

@Component({
  selector: 'app-dashboard-host',
  templateUrl: './dashboard-host.component.html'
})
export class DashboardHostComponent implements OnInit {
  ready = false;
  isV2 = false;

  constructor(
    private featureFlagService: FeatureFlagService,
    public spinner: NgxSpinnerService,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // This route also answers the site root ('/'). A provider (taxi office, bus operator) landing
    // there belongs on its own portal; the store dashboard's API would answer 401 and sign it out.
    if (this.auth.isProviderSession()) {
      void this.router.navigate(this.auth.providerHomeUrl(), { replaceUrl: true });
      return;
    }
    this.spinner.show();
    this.featureFlagService.fetchFeatures().subscribe({
      next: () => {
        this.isV2 = this.featureFlagService.isFeatureEnabled('store_dashboard_v2');
        this.ready = true;
        this.spinner.hide();
      },
      error: () => {
        this.isV2 = false;
        this.ready = true;
        this.spinner.hide();
      }
    });
  }
}
